import { useEffect as c } from "react";
import { useFunction as o } from "./index2.js";
const i = (e, n) => {
  const t = o(n);
  c(() => {
    if (!e.current)
      return;
    const r = new ResizeObserver(t);
    return r.observe(e.current), () => r.disconnect();
  }, []);
};
export {
  i as useOnResize
};
//# sourceMappingURL=index6.js.map
